module.exports = __webpack_public_path__ + "img/FR25933.4aca6877.png";